import { useEffect, useRef, useState } from "react";

const breakpoints = {xs: 0, sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1400}
const defaultCols = {xs: 1, sm: 2, md: 1, lg: 2, xl: 3, xxl: 3}

function getCurrentBreakpoint(){
    const w = window.innerWidth;
    return Object.entries(breakpoints)
        .reverse()
        .find(([k, min]) => w >= min);
}

function getCols(cols = {}) {
  const bp = getCurrentBreakpoint();
  return bp ? cols[bp[0]] : 1;
}

function setColBorders(cols, colCount){
    for (let i = 0; i < cols.length; i++) {
        /*
        i\colCount 1   2   1   2   3   3
        0         -0  +0  -0  +0  +0  +0
        1         -0  -1  -0  -1  +1  +1
        2         -0  +0  -0  +0  -2  -2
        3         -0  -1  -0  -1  +0  +0
        4         -0  +0  -0  +0  +1  +1
        5         -0  -1  -0  -1  -2  -2
        
        ([+/-] = shallAdd; [num] = modulo)
        */
        if (i % colCount === (colCount-1)) {
            cols[i]?.classList.remove("border-end");
        } else {
            cols[i]?.classList.add("border-end");
        }
    }
}

function setColClasses(children, colCount){
    const cols = [...children].filter((c) => c.className.includes("col"));
    //If there's one more column than it can be distributed, then the first shall be in a full row
    switch(cols.length % colCount){
        case 0:
            cols[0].classList.remove("price-full-row");
            setColBorders(cols, colCount);
            break;
        case 1:
            const firstCol = cols.shift();
            firstCol.classList.add("price-full-row");
            firstCol.classList.remove("border-end");
            setColBorders(cols, colCount);
            break;
        default: console.error(`Consider another rowCols value for this breakpoint: ${getCurrentBreakpoint()}`);
    }
}

function DividerGrid({children, cols=defaultCols}){
    const [colCount, setColCount] = useState(() => getCols(cols));
    const parentRef = useRef(null);

    useEffect(() => {
        const update = () => {
            setColCount(getCols(cols));
            setColClasses(parentRef.current.children, colCount);
        }

        update();

        const onResize = () => update();
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [cols, children, colCount]);

    return (
        <div className={`row row-cols-${cols.xs} row-cols-sm-${cols.sm} row-cols-md-${cols.md} row-cols-lg-${cols.lg} row-cols-xl-${cols.xl} row-cols-xxl-${cols.xxl}`} 
            ref={parentRef}>
            {children}
        </div>
    );
}

export default DividerGrid;